<template>
  <table class="b2b-table b2b-table--vstripe b2b-product-compare-table" qaid="productCompareOverview">
    <tbody>
      <template v-for="item in sectionData.compareItems">
        <tr
          v-if="showItem(item.code)"
          :key="getRowKey(item.code)"
          class="compare-chart__row"
          :qaid="`productCompareOverview-${item.code}`"
        >
          <th scope="row" :qaid="`productCompareOverviewLabel-${item.code}`">{{ item.label }}</th>
          <td
            v-for="(product, sku) in metaData.products"
            :key="getKey(item.code, sku)"
            class="compare-chart__cell"
            :data-spec="item.label"
            :qaid="`productCompareOverview-${item.code}-${sku}`"
          >
            <compare-model
              v-if="item.code === 'hero'"
              :product="item.products[sku]"
              :sku="`${sku}`"
              :base-properties="baseProperties"
              :show-remove="!meta"
              @remove-product="removeProduct"
            />
            <div v-else-if="item.code === 'priceRange' && item.products[sku] && !meta">
              <div v-if="b2b">
                <span v-if="!consumerFriendlyMode">{{ item.products[sku].formattedWasPrice }}</span>
                <span v-else>{{ item.products[sku].b2bToggleProductPriceRange }}</span>
              </div>
              <div v-else>
                <span v-if="!onSale(item.products[sku])">{{ item.products[sku].formattedWasPrice }}</span>
                <div v-else>
                  <span id="actualPrice" class="actual-price salePrice">{{ item.products[sku].formattedIsPrice }}</span>
                  <span id="wasPriceWrapper">
                    <span id="wasPrice" class="beforeSalePrice">{{ item.products[sku].formattedWasPrice }}</span>
                  </span>
                </div>
              </div>
            </div>
            <swatches
              v-else-if="item.code === 'colors' && !meta"
              :colors="item.products[sku]"
              :radio-name="`swatches-${sku}`"
              :display-only="true"
              class="justify-start"
            />
            <span v-else-if="item.code === 'powerReviewsID' && !meta">
              <a :href="metaData.products[sku].url" class="underline">
                <div :id="`pr-reviewsnippet-${item.products[sku]}`" class="pr-reviewsnippet"></div>
              </a>
            </span>
            <span v-else-if="item.code === 'projectOneUrl' && item.products[sku] && !meta">
              <a :href="`${item.products[sku]}`" class="underline">{{ bp('yes') }}</a>
            </span>
            <span v-else-if="typeof item.products[sku] === 'string' && !meta">{{ item.products[sku] }}</span>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import {mapGetters} from 'vuex';
import Swatches from '@/components/Swatches';
import CompareModel from '@/components/compare/CompareModel';

export default {
  components: {
    Swatches,
    CompareModel,
  },
  props: {
    meta: {
      type: Boolean,
      default: false,
    },
    sectionData: {
      type: Object,
      default: () => ({
        url: '',
        name: '',
        useSpecItem: false,
        images: [],
      }),
    },
    sectionKey: {
      type: String,
      required: true,
    },
    metaData: {
      type: Object,
      required: true,
    },
    reviewsRendered: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('backend', ['b2b', 'consumerFriendlyMode']),
  },

  watch: {
    sectionData() {
      // Have to make sure the page is fully loaded before attempting to init powerreviews
      if (document.readyState === 'complete') {
        this.initPowerReviews();
      } else {
        window.addEventListener('load', () => {
          this.initPowerReviews();
        });
      }
    },
  },

  methods: {
    removeProduct(productId) {
      this.$delete(this.metaData.products, productId);
    },

    onSale(priceObject) {
      return priceObject.formattedIsPrice != null;
    },

    getKey(code, sku) {
      return `${sku}${code}-${this.meta ? 'meta' : ''}`;
    },

    getRowKey(itemCode) {
      return `${itemCode}-${this.meta ? 'meta' : ''}`;
    },

    showItem(itemCode) {
      if (this.meta && !(itemCode == 'hero')) return false;
      return true;
    },

    initPowerReviews() {
      // powerreviews.display.render() must be used only once per page load
      if (window.POWERREVIEWS && !this.reviewsRendered) {
        let reviews = [];

        this.sectionData.compareItems.forEach((compareItem) => {
          if (compareItem.code === 'powerReviewsID') {
            for (let product in compareItem.products) {
              let powerReview = {
                locale: $('.pr_locale').val(),
                merchant_group_id: $('.pr_merchant_group_id').val(),
                page_id: compareItem.products[product],
                merchant_id: $('.pr_merchant_id').val(),
                api_key: $('.pr_api_key').val(),
                review_wrapper_url: '',
                components: {
                  CategorySnippet: 'pr-reviewsnippet-' + compareItem.products[product],
                },
              };

              reviews.push(powerReview);
            }
          }
        });

        if (reviews && reviews.length) {
          window.POWERREVIEWS.display.render(reviews);
          this.$emit('reviews-rendered');
        }
      }
    },
  },
};
</script>
